<template>
  <!-- ui-input -->
  <div class="relative">
    <label
      :class="labelClassNames"
      :for="id"
      class="absolute px-1 transition-all duration-150 transform"
      >{{ label }}</label
    >
    <input
      :id="id"
      :value="value"
      @input="updateValue($event.target.value)"
      @focus="isFocused = true"
      @blur="isFocused = false"
      ref="input"
      class="block w-full p-4 text-gray-900 transition duration-150 border-2 outline-none text-medium h-14 focus:border-blue"
      type="text"
    />
  </div>
</template>
<script>
import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
  data() {
    return {
      isFocused: false,
      id: `id-${uuidv4()}`
    };
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * @returns {Boolean}
     */
    isFilled() {
      return this.value !== "";
    },
    /**
     * @returns {String}
     */
    labelClassNames() {
      if (this.isFocused) {
        return "text-blue translate-x-1 -translate-y-1/2 scale-75 bg-white";
      } else if (this.isFilled) {
        return "text-gray-500 translate-x-1 -translate-y-1/2 scale-75 bg-white";
      }
      return "text-gray-500 text-medium translate-x-3 translate-y-4";
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.input.focus();
    }
  }
});
</script>
<style></style>
